module.exports = __webpack_public_path__ + "PTMETTAhome-3.08f26893.png";